// @flow

import React, { useContext } from 'react';
import { Link, Logo } from 'operation-diameter';

import styles from './Header.module.scss';
import { useCopy } from 'hooks/useCopy';
import { UserContext } from 'shared/userContext/UserContext';
import Cookie from 'js-cookie';

const Header = () => {
  const userLoggedIn = Cookie.get('originations_ui_user_logged_in') === 'true';
  const { type: userType } = useContext(UserContext);
  const { getCopy } = useCopy(userType, 'components.layout.header');

  return (
    <header className={styles.header} data-testid='header'>
      <Logo url='/' height='30' />
      <Link href='/login' isExternal>
        {userLoggedIn ? getCopy('link.label') : getCopy('link.signInLabel')}
      </Link>
    </header>
  );
};

export default Header;
